import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { ILookupSite } from '../../../../Models/ILookupSite';
import { LookupService } from 'src/app/Services/LookupService';
import { FormESYEligibilityWorksheetService } from "../../../../Services/FormESYEligibilityWorksheetService";
import { IFormESYEligibilityWorksheet } from "../../../../Models/Forms/IFormESYEligibilityWorksheet";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';

@Component({
  selector: 'ESYEligibilityWorksheet',
  templateUrl: './FormESYEligibilityWorksheet.component.html',
  styleUrls: ['./FormESYEligibilityWorksheet.component.css']
})

export class FormESYEligibilityWorksheetComponent extends SpinnerBase implements OnInit {

  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  lookupSite: any = [];
  lookupSiteList: ILookupSite[];
  _lookupService: LookupService;
  formESYEligibilityWorksheetDB: any = [];
  reportParamArray: IReportParameter[];

  constructor(
    private globals: Globals, reportService: ReportService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router,
    lookupService: LookupService,
    private _formESYEligibilityWorksheetService: FormESYEligibilityWorksheetService) {
    super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
  }

  ngOnInit() {
    this.LoadFormESYEligibilityWorksheetDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
  }

  LoadFormESYEligibilityWorksheetDetails(): void {
    this._formESYEligibilityWorksheetService.getFormESYEligibilityWorksheet(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormESYEligibilityWorksheet) => {
        this.formESYEligibilityWorksheetDB = res
      },
        err => console.error(err)
      );
  }

  // Section 2 only applies when question 5 on page 1 is answered Yes.
  section2Disabled(): boolean {
    return !this._myGlobals.editMode || this.formESYEligibilityWorksheetDB.requiresEsyForIndependence !== true;
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });

  }

  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    this._formESYEligibilityWorksheetService.insertUpdateFormESYEligibilityWorksheet(this.formESYEligibilityWorksheetDB)
      .subscribe((res: IFormESYEligibilityWorksheet) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.LoadFormESYEligibilityWorksheetDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )

  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormESYEligibilityWorksheetDetails();
  }


  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'FormInstanceID', parameterValue: this.formESYEligibilityWorksheetDB.formInstanceId.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'BlankForm', parameterValue: 'False' },
      { parameterName: 'ShowWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False' },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formESYEligibilityWorksheetDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formESYEligibilityWorksheetDB.rdlFileNameSpanish, this.reportParamArray);
  }

}
